<style src="css/recordDetails.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="记录详情"></topbar>
        <div class="recordList">
            <div class="recordItem"  v-for="(item,index) in scaleUserAllBespeakNote">
                <div class="circular"></div>
                <div class="itemRight">
                    <div class="timeBox">
                        <div class="time">{{item.time}}</div>
                        <div class="arrow" @click="getUserBespeakNoteOrDiscuss(item.id,1,item.status,index)">{{item.status?'收起':'展开'}}<div class="icon" :class="{active:item.status}"></div></div>
                    </div>
                    <div class="inputBox" v-if="item.status">
<!--                        <div class="title">咨询方式：</div>-->
<!--                        <div class="infoValue">{{scaleUserBespeak.serveType | isServeType}}</div>-->
                        <div class="title">问题类型：</div>
                        <div class="infoValue"><span style="margin-right: 8px" v-for="item in troubles">{{item}}</span></div>
                        <div class="title">1.讨论议题，需特别关注之处：</div>
                        <input type="text" disabled v-model="scaleUserBespeakNote.focus">
                        <div class="title">2.本次咨询目标：</div>
                        <input type="text" disabled v-model="scaleUserBespeakNote.target">
                        <div class="title">3.问题分析:</div>
                        <input type="text" disabled v-model="scaleUserBespeakNote.description">
                        <div class="title">4.处理结果</div>
                        <input type="text" disabled v-model="scaleUserBespeakNote.result">
                        <div class="selectBox">
                            <div class="selectItem" v-for="item in resultTypeList">
                                <div class="resultType" :class="{active:item.resultType===scaleUserBespeakNote.resultType}"></div>
                                {{item.name}}
                            </div>
                        </div>
                        <div class="title">5.后续安排（建议下一次咨询时间）</div>
                        <input type="text" disabled v-model="scaleUserBespeakNote.followUp">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                bespeakId:this.$route.query.bespeakId?this.$route.query.bespeakId:'',
                scaleUserAllBespeakNote:[],
                resultTypeList:[
                    {
                        name: '继续咨询',
                        resultType: 0
                    },
                    {
                        name: '建议就医',
                        resultType: 1
                    },
                    {
                        name: '反馈院系',
                        resultType: 2
                    },
                    {
                        name: '危机干预',
                        resultType: 3
                    },
                ],
                scaleUserBespeakNote:'',
                troubles:'',
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },

            isServeType(v){
                let arr = ['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[v]
            },
        },
        computed: {},
        methods: {
            async getUserBespeakNoteOrDiscuss(id,n,status,index) {
                if(status){
                    this.scaleUserAllBespeakNote[index].status=false
                    this.scaleUserBespeakNote=''
                    this.troubles=''
                    return
                }else{
                    this.scaleUserAllBespeakNote.forEach(v=>{
                        v.status=false
                    })
                    this.scaleUserAllBespeakNote[index].status=true
                }
                let obj = {}
                obj.bespeakId = id;
                obj.type = n;
                let data = await getSources("/bear-scale/api/scaleUserBespeak/getUserBespeakNoteOrDiscuss.json", obj);
                if (data.status === 0) {
                    // if(data.scaleUserBespeakDiscuss){
                    //     this.scaleUserBespeakDiscuss = data.scaleUserBespeakDiscuss;
                    // }
                    if(data.scaleUserBespeakNote){
                        this.scaleUserBespeakNote = data.scaleUserBespeakNote;
                    }
                    this.troubles = JSON.parse(data.troubles);
                }else{
                    alert(data.msg)
                }
            },
            async getScaleUserAllBespeakNote() {
                console.log(1)
                let obj = {}
                obj.bespeakId = this.bespeakId;
                let data = await getSources("/bear-scale/api/scaleUserBespeak/getScaleUserAllBespeakNote.json", obj);
                if (data.status === 0) {
                    let arr = [];
                    data.scaleUserAllBespeakNote.forEach(v=>{
                        arr.push({
                            id:v.split("_")[0],
                            time:v.split("_")[1],
                            status:false
                        })
                    })
                    this.scaleUserAllBespeakNote=arr
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {
            this.getScaleUserAllBespeakNote()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/recordDetails.vue